import React from 'react'
import SideNav from'./Admin'
import PastOrders from './PastOrders'
import Sidebar from './Sidebar'
export default function ViewOrderStatus() {
  return (
    <div>
           <Sidebar/>
        <PastOrders/></div>
  )
}
